import LotusGoFreshModel from "assets/pages/Dashboard/BuildingImage/LotusGoFreshModel.svg";

export const LotusGoFresh = () => {
  return <img src={LotusGoFreshModel} />;
};
